import { AddCustomRepairTimeItemsRequest, useAddCustomRepairTimeItems } from "@tm/data/basket"
import { useCallback } from "react"
import { OwnWorkRequest } from "../WorkEditDialog"

export const useSaveOwnWork = () => {
    const { mutateAsync: saveNewRepairTime } = useAddCustomRepairTimeItems()

    return useCallback(
        async (repairTimeRequest: OwnWorkRequest) => {
            try {
                if (repairTimeRequest.description) {
                    const request: AddCustomRepairTimeItemsRequest = {
                        customRepairTimeItemsToAdd: [repairTimeRequest],
                        repairTimeDivision: 1,
                    }
                    await saveNewRepairTime(request)
                }

                return true
            } catch {
                return false
            }
        },
        [saveNewRepairTime]
    )
}
